
import React from 'react'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'

const FactorTextField = ({ label, onTextFieldChange, placeholder, value, ...rest }) => (
  <TextField
    label={label}
    id={value === '' ? 'new-factor' : value }
    onChange={event => onTextFieldChange(event)}
    placeholder={placeholder}
    style={{ display: 'block' }}
    value={value}
    {...rest}
  />
)

FactorTextField.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  onTextFieldChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
}

export default FactorTextField


// WEBPACK FOOTER //
// ./src/components/counseling-session/enter-factors/FactorTextField.js